/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { HttpMethods, TransportRequestTypes } from '../../../../core';
import { clearBaseRequestFieldsFromData } from '../../../../helpers/request-helpers';

import type { NextFunction, TransportMiddlewareContext, TransportMiddlewareRequest, TransportMiddlewareResponse } from '../../../../core';

export const processBodyMiddleware = <T, R, E>(
    next: NextFunction<TransportMiddlewareResponse<R, E> | Error>,
    ctx: TransportMiddlewareContext,
    req: TransportMiddlewareRequest<T>,
    res: TransportMiddlewareResponse<R, E>
) => {
    const { middlewareConfigs, commands } = ctx;
    const { processBodyMiddleware } = middlewareConfigs;
    const { originalData, options } = req;
    const { requestInit, type } = options;
    const isGetRequest = requestInit.method === HttpMethods.Get;
    const isFormDataUpload = type === TransportRequestTypes.ToUploadFormData;

    if (processBodyMiddleware?.trackAutoUpdates) {
        if (!originalData || (originalData && !(originalData as any).rcopAutoUpdate)) {
            commands.setLastActiveTime();
        }

        if (originalData && originalData.hasOwnProperty('rcopAutoUpdate')) {
            delete (originalData as any).rcopAutoUpdate;
        }
    } else {
        commands.setLastActiveTime();
    }

    const clearedOriginalData = originalData ? clearBaseRequestFieldsFromData(originalData) : originalData;

    req.data = isGetRequest
        ? undefined
        : clearedOriginalData
            ? isFormDataUpload ? clearedOriginalData as unknown as FormData : JSON.stringify(clearedOriginalData)
            : undefined;

    next();
};
